import { DOCUMENT } from "@angular/common";
import {
	Component,
	Inject,
	ViewChild,
	ElementRef,
	OnInit,
	Renderer2,
	HostListener,
	AfterViewInit,
} from "@angular/core";
import { Router } from "@angular/router";
import { ConfigService } from "src/app/config/config.service";
import { RightSidebarService } from "src/app/core/service/rightsidebar.service";
import { WINDOW } from "src/app/core/service/window.service";
import { LanguageService } from "src/app/core/service/language.service";
import { UnsubscribeOnDestroyAdapter } from "src/app/shared/UnsubscribeOnDestroyAdapter";
import { AuthService } from "src/app/authentication/services/auth.service";
import { ActivatedRoute, NavigationExtras } from "@angular/router";
import { SweetAlertService } from "src/app/services/shared-service/sweetalert/sweet-alert.service";
import { MatSnackBar } from "@angular/material/snack-bar";


const document: any = window.document;

@Component({
	selector: "app-header",
	templateUrl: "./header.component.html",
	styleUrls: ["./header.component.scss"],
})
export class HeaderComponent
	extends UnsubscribeOnDestroyAdapter
	implements OnInit, AfterViewInit
{
	public config: any = {};
	isNavbarCollapsed = true;
	isNavbarShow: boolean;
	flagvalue;
	countryName;
	langStoreValue: string;
	defaultFlag: string;
	isOpenSidebar: boolean;
	userName: string;
	showSwitch: boolean = false;
	clientList: any = [];
	org_name=localStorage.getItem('org_name');
	type = localStorage.getItem("type");

	public searchText: string = ''; // Bound to the search input
	public filteredClients: any[] = []; // Filtered list of client
	selectedClient: any = null; // Track the selected client
	// Reference to the search input field
	@ViewChild('searchInput') searchInput: ElementRef;

	constructor(
		@Inject(DOCUMENT) private document: Document,
		@Inject(WINDOW) private window: Window,
		private renderer: Renderer2,
		public elementRef: ElementRef,
		private rightSidebarService: RightSidebarService,
		private configService: ConfigService,
		private authService: AuthService,
		private router: Router,
		public languageService: LanguageService,
    private snackbar : MatSnackBar
	) {
		super();
	}
	listLang = [
		{ text: "English", flag: "assets/images/flags/us.jpg", lang: "en" },
		{ text: "Spanish", flag: "assets/images/flags/spain.jpg", lang: "es" },
		{ text: "German", flag: "assets/images/flags/germany.jpg", lang: "de" },
	];
	@HostListener("window:scroll", [])
	onWindowScroll() {
		const offset =
			this.window.pageYOffset ||
			this.document.documentElement.scrollTop ||
			this.document.body.scrollTop ||
			0;
		if (offset > 50) {
			this.isNavbarShow = true;
		} else {
			this.isNavbarShow = false;
		}
	}
	ngOnInit() {
		this.config = this.configService.configData;
    	this.userName = localStorage.getItem("org_name").slice(0, 2).toUpperCase()
		this.langStoreValue = localStorage.getItem("lang");
		const val = this.listLang.filter((x) => x.lang === this.langStoreValue);
		this.countryName = val.map((element) => element.text);
		if (val.length === 0) {
			if (this.flagvalue === undefined) {
				this.defaultFlag = "assets/images/flags/us.jpg";
			}
		} else {
			this.flagvalue = val.map((element) => element.flag);
		}
		//for switch account
		let client = localStorage.getItem("authClients");
		let authClients = client ? JSON.parse(client) : null;
		this.showSwitch = authClients && authClients.length > 1;
		this.clientList = authClients;		
		  
    //profile icon usernmae subs
    // this.authService.profileIconName$.subscribe()
    this.authService.profileIconName$.subscribe({
      next:(value:string)=> {
        this.userName =value?.slice(0, 2).toUpperCase()
      }
    })

	// Retrieve selected client from localStorage on component initialization
    const storedClientId = localStorage.getItem('user_id');
    if (storedClientId) {
      this.selectedClient = this.clientList.find(client => client._id === storedClientId) || null;
    }

	// Initialize the filtered client list
    this.filteredClients = [...this.clientList];
	}
	ngAfterViewInit() {
		// set theme on startup
		if (localStorage.getItem("theme")) {
			this.renderer.removeClass(this.document.body, this.config.layout.variant);
			this.renderer.addClass(this.document.body, localStorage.getItem("theme"));
		} else {
			this.renderer.addClass(this.document.body, this.config.layout.variant);
		}

		if (localStorage.getItem("menuOption")) {
			this.renderer.addClass(
				this.document.body,
				localStorage.getItem("menuOption")
			);
		} else {
			this.renderer.addClass(
				this.document.body,
				"menu_" + this.config.layout.sidebar.backgroundColor
			);
		}

		if (localStorage.getItem("choose_logoheader")) {
			this.renderer.addClass(
				this.document.body,
				localStorage.getItem("choose_logoheader")
			);
		} else {
			this.renderer.addClass(
				this.document.body,
				"logo-" + this.config.layout.logo_bg_color
			);
		}

		if (localStorage.getItem("sidebar_status")) {
			if (localStorage.getItem("sidebar_status") === "close") {
				this.renderer.addClass(this.document.body, "side-closed");
				this.renderer.addClass(this.document.body, "submenu-closed");
			} else {
				this.renderer.removeClass(this.document.body, "side-closed");
				this.renderer.removeClass(this.document.body, "submenu-closed");
			}
		} else {
			if (this.config.layout.sidebar.collapsed === true) {
				this.renderer.addClass(this.document.body, "side-closed");
				this.renderer.addClass(this.document.body, "submenu-closed");
			}
		}
	}
	callFullscreen() {
		if (
			!document.fullscreenElement &&
			!document.mozFullScreenElement &&
			!document.webkitFullscreenElement &&
			!document.msFullscreenElement
		) {
			if (document.documentElement.requestFullscreen) {
				document.documentElement.requestFullscreen();
			} else if (document.documentElement.msRequestFullscreen) {
				document.documentElement.msRequestFullscreen();
			} else if (document.documentElement.mozRequestFullScreen) {
				document.documentElement.mozRequestFullScreen();
			} else if (document.documentElement.webkitRequestFullscreen) {
				document.documentElement.webkitRequestFullscreen();
			}
		} else {
			if (document.exitFullscreen) {
				document.exitFullscreen();
			} else if (document.msExitFullscreen) {
				document.msExitFullscreen();
			} else if (document.mozCancelFullScreen) {
				document.mozCancelFullScreen();
			} else if (document.webkitExitFullscreen) {
				document.webkitExitFullscreen();
			}
		}
	}
	setLanguage(text: string, lang: string, flag: string) {
		this.countryName = text;
		this.flagvalue = flag;
		this.langStoreValue = lang;
		this.languageService.setLanguage(lang);
	}
	mobileMenuSidebarOpen(event: any, className: string) {
		const hasClass = event.target.classList.contains(className);
		if (hasClass) {
			this.renderer.removeClass(this.document.body, className);
		} else {
			this.renderer.addClass(this.document.body, className);
		}
	}
	callSidemenuCollapse() {
		const hasClass = this.document.body.classList.contains("side-closed");
		if (hasClass) {
			this.renderer.removeClass(this.document.body, "side-closed");
			this.renderer.removeClass(this.document.body, "submenu-closed");
		} else {
			this.renderer.addClass(this.document.body, "side-closed");
			this.renderer.addClass(this.document.body, "submenu-closed");
		}
	}
	public toggleRightSidebar(): void {
		this.subs.sink = this.rightSidebarService.sidebarState.subscribe(
			(isRunning) => {
				this.isOpenSidebar = isRunning;
			}
		);

		this.rightSidebarService.setRightSidebar(
			(this.isOpenSidebar = !this.isOpenSidebar)
		);
	}

	isSelected(client: any): boolean {
		return this.selectedClient && this.selectedClient._id === client._id;
	}
	

	filterClients() {
		const searchTerm = this.searchText.toLowerCase();
		this.filteredClients = this.clientList.filter((client) =>
		  client.organization_name.toLowerCase().includes(searchTerm)
		);
	  }

	logout() {
		localStorage.removeItem("token");
		localStorage.removeItem("user_id");
		localStorage.removeItem("role_name");
		localStorage.removeItem("passwordPolicy");
		localStorage.removeItem("username");
		localStorage.removeItem("org_name");
		sessionStorage.clear();

		this.router.navigate(["/authentication/signin"]);
	}
	switchAccount(client: any,index:string) {
		// Store selected client in a variable and persist it in localStorage
		this.selectedClient = client;

		// Clear the search box and reset filtered clients
		this.searchText = '';
		this.filteredClients = [...this.clientList];

		localStorage.setItem("user_id", client._id);
		localStorage.setItem("org_name", client.organization_name);
		localStorage.setItem("org_id", client._id);
		this.org_name = client.organization_name;
		this.authService.setProfileName(client.organization_name);
		
		// Focus back to the search input field after client switch
		if (this.searchInput) {
			this.searchInput.nativeElement.focus();
		  }
    
	// 	//update style of client list drop down
    //   const element = document.getElementById(index)
    //   element.classList.add('text-info')
    //   element.classList.add('selectedClientDropDown')
    //   //and remove text-info class if any one has except current switched account
    //   this.clientList.forEach((value,i) => {
    //     if(i!=index){
    //       const element = document.getElementById(i)
    //       element.classList.remove('text-info')
    //       element.classList.remove('selectedClientDropDown')
    //     }
    //   });
    //
    this.snackbar.open(`Account switched to ${client.organization_name}`, 'close', {
			duration: 500,
			verticalPosition: 'top',
			horizontalPosition: 'center',
			panelClass: 'black'
		});
		const navigationExtras: NavigationExtras = {
			queryParams: { "switched-account": client.organization_name },
		};
		this.router.navigate(["/client/dashboard"], navigationExtras);
	}
}
